module.exports = __webpack_public_path__ + "static/media/dot-loader.39e1b29a.gif";